import React from 'react';

import PrimaryLink from '../../buttons/PrimaryLink';
import PageSection from './PageSection';
import pageRoutes from '../../../router/pageRoutes';

const BuildAgentCTASection: React.FC = () => {
  return (
    <PageSection>
      <div className="text-center max-w-2xl mx-auto py-8 flex flex-col gap-6 items-center">
        <p className="text-5xl font-medium">Is there a specific agent you want us to build for your business?</p>
        <PrimaryLink href={pageRoutes.Demo} className="bg-purple text-pureWhite font-semibold py-3 px-8 hover:opacity-90 transition-opacity">
          Let&apos;s talk
        </PrimaryLink>
      </div>
    </PageSection>
  );
};

BuildAgentCTASection.displayName = 'BuildAgentCTASection';
export default BuildAgentCTASection;
